import * as React from 'react';
import { useEffect } from 'react';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { PluginListenerHandle } from '@capacitor/core';
import config from '../../config.general';
import { useNavigateWithAppName } from './NavigateWithAppName';

const AppUrlListener: React.FC = () => {
	const navigate = useNavigateWithAppName();
	const lastNavTimeRef = React.useRef<number>(0);
	const appDomains = config.appDomain.split(',');

	const tryNavigate = (url: string) => {
		const now = Date.now();
		if (now - lastNavTimeRef.current > 1000) {
			// 1 second debounce
			lastNavTimeRef.current = now;
			navigate(url);
		}
	};

	useEffect(() => {
		const checkLaunchArgs = async () => {
			// Handle app launch from notification
			const result = await App.getLaunchUrl();
			const slug = getPageSlugFromUrl(appDomains, result?.url);
			if (slug) tryNavigate(slug);
		};

		checkLaunchArgs();

		let listener: PluginListenerHandle;

		const setupListener = async () => {
			listener = await App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
				const slug = getPageSlugFromUrl(appDomains, event?.url);
				if (slug) tryNavigate(slug); // If no match, do nothing - let regular routing logic take over
			});
		};

		setupListener();

		return () => {
			if (listener) listener.remove();
		};
	}, []);

	return null;
};

export default AppUrlListener;

const getPageSlugFromUrl = (appDomains: string[], url: string) => {
	if (!url) return null;

	const matchedDomain = appDomains.find((domain) => url.startsWith(domain));
	if (!matchedDomain) return null;

	return url.replace(matchedDomain, ''); // appDomain should NOT include '/` in the end
};
